export default "__VITE_ASSET__ecWwTqtv__"